/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Enum for organization roles
 */
export var OrganizationRoles;

(function (OrganizationRoles) {
  OrganizationRoles["JOVE_ADMIN"] = "jove-admin";
  OrganizationRoles["ORG_ADMIN"] = "org-admin";
})(OrganizationRoles || (OrganizationRoles = {}));